import angular from "angular";
import _ from "lodash";
import {Util} from "@common/util";

export class ShowCustomAttrController {
        customAttributeTemplate;
        subLoaded;
        model;
        updateLoader: any;
        reqFlds;
        formUtils;
        static $inject = ['$q', '$rootScope', '$scope', '$uibModalInstance', 'ApiAdapterService', '$validation',
            'CacheService', 'APIService', 'SnackbarService', 'BroadcastService',
            'team', 'apiParams', '$http', '$timeout', 'CommonService', '$state', 'FormService',
            'FormsUtilityFactory'];

        constructor(private $q, private $rootScope, private $scope, private $uibModalInstance, private $_api, private $validation,
            private $_cache, private APIService, private $_snack,
            private BroadcastService, private team, private apiParams, private $http, private $timeout, private $_com, private $state, private FormService, private FormsUtilityFactory: any) {
            var cstmAttrVm: any = this;
            cstmAttrVm.flag = false;
            this.formUtils = this.FormsUtilityFactory.create('cstmAttrForm', this.$scope);

            this.APIService.callApi(this.apiParams['url'],
                this.apiParams['method'],
                this.apiParams['bodyParams'],
                this.apiParams['queryParams']
            ).then((resp) => {
                //////// For local testing ///////////////
                // this.$http.get('http://localhost:3000/teamsCstmAttr/ficw_my_background').then(s => {
                //     this.customAttributeTemplate = s.data;
                //     this.subLoaded = true;
                // });
                this.customAttributeTemplate = resp.data;
                this.subLoaded = true;
            });
        }

        submitCstmAttrForm = (updateDetails) => {
            var deferred = this.$q.defer();
            this.formUtils.resetBckndErrors(this.$scope);

            if(!this.formUtils.isModelChanged()){
                this.updateLoader = false;
                this.$rootScope.mainShowLoader = null;
                let vldMsg = 'There are no updates to submit.';
                this.$_snack.showErrorToastr({ message: vldMsg });
                deferred.reject();
                return deferred.promise;
            }

            this.formUtils.handleRequiredFieldValidations(this.$timeout, 'cstm-attr-popup', 'updateDetails');
            //////
            this.$validation.validate(updateDetails).then(() => {
                this.updateLoader = "Updating Information";

                if(this.formUtils.isMultipleTeams){
                    let customAttributesMap;
                    let subjects, formDocs;
                    customAttributesMap = this.formUtils.generateResponse();
                        subjects = customAttributesMap.subject;
                        delete customAttributesMap.subject;
                        formDocs = customAttributesMap.formDocs;
                        delete customAttributesMap.formDocs;
                        subjects.forEach( (s, index) => {
                            let totalDocs=0;
                            s.photoMimeType = "image/jpeg";
                            if (!!s.photo && s.photo.indexOf(',') != -1)
                                s.photo = s.photo.split(',')[1];
                            s.customAttributesMap = _.cloneDeep(customAttributesMap);
                            let subBackup = this.formUtils.modelBak.subject[index];
                            let subModel = this.formUtils.parsedModel.subject[index];
                            Object.keys(s).forEach(k => {
                                if (k != 'customAttributesMap' && !_.isEqual(subBackup[k], subModel[k])) {
                                    s.customAttributesMap[k] = s[k];
                                }
                                if(_.includes(this.formUtils.cstmAttrFlds, k)) {
                                    delete s[k];
                                }
                            })
                            s.subjectTypeId = 'INDIVIDUAL';
                            s.password = this.$_cache.getPassword();

                            if(!!formDocs && !!formDocs['subject']) {
                                s.uuid = this.$_com.uuidv4();
                                Object.keys(formDocs['subject'][index]).forEach(k => {
                                    totalDocs +=  formDocs['subject'][index][k].length;
                                })
                                this.FormService.uploadFrmDocs(s.uuid,formDocs['subject'][index],totalDocs,'CREATE_TEAM').then(() => {
                                    },(err) => {
                                        this.updateLoader = false;
                                        this.$_snack.showErrorToastr({message: Util.FAILURE_MSG});
                                        deferred.reject(err);
                                    });
                            }
                        });


                    this.$_api.updateMultipleSubjects(subjects).then(() => {
                        this.updateLoader = false;
                        this.$state.go('parent-dashboard', { ref: '' }, { reload: true }).then(()=>{
                            deferred.resolve();
                        });
                        var successMsg = "Submitted successfully. You will be notified when the teams are updated.";
                        toastr.success(successMsg);
                        deferred.resolve();
                        this.$uibModalInstance.close("Success");
                    }, (error) => {
                        this.updateLoader = false;
                        !!error && this.formUtils.handleErrors(error, this.$rootScope);
                        deferred.reject();
                    });
                } else {
                    //Need to send only minimal data while updating cstm attr
                    var teamModel:{
                        customAttributesMap?: any,
                        subjectTypeId?: string,
                        subjectId?: string
                    } = {
                        subjectTypeId: this.team.subjectTypeId,
                        subjectId: this.team.subjectId
                    };
                    if (!!this.model) {
                        teamModel.customAttributesMap = this.formUtils.generateResponse();
                        !!this.apiParams.validateSection && (Object.assign(teamModel, {"validateSection" : this.apiParams.validateSection}));
                    }
                    this.$_api.updateCstmAttr(teamModel, this.$_cache.getPassword()).then(() => {
                        this.updateLoader = false;
                        if (isIE11) {
                            this.BroadcastService.broadcast('team-updated-inIE11', [{ subjectId: this.team.subjectId }]);
                        }
                        this.BroadcastService.broadcast('add-new-team');
                        var successMsg = "Your Care Recipient’s profile has been successfully updated.<br />";
                        if (this.team.subjectTypeId == 'PROJECT') {
                            successMsg = "Your Project profile has been successfully updated.<br />";
                        }
                        toastr.success(successMsg);
                        deferred.resolve();
                        this.$uibModalInstance.close("Success");
                    }, (error) => {
                        this.updateLoader = false;
                        !!error && this.formUtils.handleErrors(error, this.$rootScope);
                        deferred.reject();
                    });
                }
            }, (e) => {
                this.updateLoader = false;
                console.log("Validation Error:", e);
                let vldMsg = 'Please correct any errors before submitting';
                this.$_snack.showErrorToastr({ message: vldMsg });
                deferred.reject();
                return;
            });
            return deferred.promise;
        }

        cancel = (): void => {
            this.formUtils.resetBckndErrors(this.$scope);
            this.$uibModalInstance.dismiss();
        }
    }

angular.module('eCareVault.customAttributeTemplate')
    .controller('ShowCustomAttrController', ShowCustomAttrController);
